import { Component, OnInit } from '@angular/core';
import { CorePageBaseComponent } from '../core-page-base.component';

@Component({
  selector: 'cu-dynamic-page-alert',
  templateUrl: './page-alert.component.html',
  standalone: false
})
export class PageAlertComponent extends CorePageBaseComponent implements OnInit {
  public ngOnInit(): void {}
  public getMessage(): string {
    if (this.page.helper.isPageComplete && this.page.saveIsFailed)
      return 'Unable to connect and save your application. Please refresh or try again at a later time';
    if (this.page.helper.isPageComplete && this.page.actionLogicIsFailed && typeof this.page.config.errorOnActionLogic === 'string')
      return this.page.config.errorOnActionLogic;
    return `Please resolve the errors <span class="bl-font-color--error">in red</span> to continue`;
  }

  public getHeader(): string {
    if (this.page.helper.isPageComplete && this.page.saveIsFailed) return '';
    if (this.page.helper.isPageComplete && this.page.actionLogicIsFailed) return '';
    return 'Some of the below fields are missing or contain errors';
  }
}
